import { render, staticRenderFns } from "./deleteProfile.vue?vue&type=template&id=4f7b0f71&"
import script from "./deleteProfile.vue?vue&type=script&lang=js&"
export * from "./deleteProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports